import icon from 'assets/images/check.svg'

const SubscriptionPlan = props => (
  <div className='subscription-plan'>
    <div>{ props.title }</div>
    <img src={props.icon} />
    <div>
      <span className='subscription-price'>${ props.price }</span>
      <span className='subscription-interval'>/month</span>
    </div>
    <div>
      { props.benefits.map(b =>
        <div key={b} className='subscription-benefit'>
          <img src={icon} />
          <span>{ b }</span>
        </div>
      ) }
    </div>
    <button className='col-12' onClick={props.onClick} disabled>
      Coming Soon
    </button>
  </div>
)

export default SubscriptionPlan
